const initialState = {
    isSignedIn: false,
    accessToken: null,
    refreshToken: null,
    userSequence: -1,
    role: null,
    fullName: null,
    rememberSignedId: false,
    lastSignedInId: null
};

// eslint-disable-next-line default-param-last
export default function accountReducer(state = initialState, action) {
    switch (action.type) {
        case 'SIGN_OUT':
            state = {
                ...state,
                isSignedIn: false,
                accessToken: null,
                refreshToken: null,
                userSequence: -1,
                fullName: null,
                role: null,
                userInfo: {}
            };
            return { ...state };
        case 'SIGN_IN':
            state = {
                isSignedIn: action.isSignedIn,
                accessToken: action.accessToken,
                refreshToken: action.refreshToken,
                userSequence: action.userSeq,
                role: action.role,
                fullName: action.fullName,
                rememberSignedId: action.rememberSignedId,
                lastSignedInId: action.lastSignedInId
            };
            return { ...state };
        case 'REFRESH_ACCESS_TOKEN':
            state = {
                ...state,
                accessToken: action.token
            };
            return { ...state };
        default:
            return state;
    }
}
